import { createSelector } from 'reselect';
import { flow } from 'fp-ts/function';
import { array } from 'fp-ts';
import { createAsyncActionTypes, createAction } from '@mews/framework';
import { Companionship } from '@mews-commander/data-access';
import { getStringProp, primitiveTypeUniq } from '@mews/fp';
import { ApplicationState } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import prefix from '../prefix';
import moduleSelector from '../selector';
import { createBaseEntitySelectors, createEntitiesReducer, createEntityPropertyIncludesSelector } from './utils';

export const NAME = 'companionships';

export const COMPANIONSHIPS_LOADED = prefix('COMPANIONSHIPS_LOADED');
const COMPANIONSHIPS_DELETED = prefix('COMPANIONSHIPS_DELETED');

export const COMPANIONSHIP_UPDATE = prefix('COMPANIONSHIP_UPDATE');
export const [COMPANIONSHIP_UPDATE_STARTED, COMPANIONSHIP_UPDATE_SUCCEEDED, COMPANIONSHIP_UPDATE_FAILED] =
    createAsyncActionTypes(COMPANIONSHIP_UPDATE);
export const COMPANIONSHIP_DELETE = prefix('COMPANIONSHIP_DELETE');

export const assignCompanionship =
    ({ companionshipId, reservationId }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const promise = container().companionshipComponent.update({ companionshipId, reservationId });
        return dispatch(createFetchAction(COMPANIONSHIP_UPDATE, promise));
    };

export const unassignCompanionship =
    (companionshipId: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const promise = container().companionshipComponent.update({ companionshipId, reservationId: null });
        return dispatch(createFetchAction(COMPANIONSHIP_UPDATE, promise));
    };

export const deleteCompanionship =
    (companionshipId: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const promise = container()
            .companionshipComponent.delete({ companionshipId })
            .then(() => dispatch(deleteCompanionships({ companionshipId })));
        return dispatch(createFetchAction(COMPANIONSHIP_DELETE, promise));
    };

export const setCompanionships = (companionships: $TSFixMe) =>
    createAction(COMPANIONSHIPS_LOADED, { entities: companionships });
export const deleteCompanionships = ({ companionshipId }: { companionshipId: string }) =>
    createAction(COMPANIONSHIPS_DELETED, { id: companionshipId });

export const companionshipsReducer = createEntitiesReducer({
    FETCH_SUCCESS: COMPANIONSHIPS_LOADED,
    DELETE_SUCCESS: COMPANIONSHIPS_DELETED,
    UPDATE_SUCCESS: COMPANIONSHIP_UPDATE_SUCCEEDED,
});

export const [getCompanionships] = createBaseEntitySelectors<ApplicationState, Companionship, typeof NAME>(
    moduleSelector,
    NAME
);
export const getCompanionshipsByReservationIds = createEntityPropertyIncludesSelector(
    getCompanionships,
    'reservationId',
    'reservationIds'
);

export const getCompanionshipsAccountIdsByReservationIds = createSelector(
    getCompanionshipsByReservationIds,
    flow(
        array.map((c) => c.companionId),
        primitiveTypeUniq
    )
);

export const getUnassignedCompanionships = createSelector(
    getStringProp('groupId'),
    getCompanionships,
    (groupId, companionships) =>
        Object.values(companionships).filter((c) => c.groupId === groupId && c.reservationId == null)
);
export const getUnassignedCompanionshipsAccountIds = createSelector(
    getUnassignedCompanionships,
    flow(
        array.map((c) => c.companionId),
        primitiveTypeUniq
    )
);
